import React, { useState, useEffect } from "react";
import withDimension from "utils/withDimension";
import { MAX_RESPONSIVE_MOBILE } from "store/constants";
import client from "data/Home/client.json";
import ClientDesktop from "./ClientDesktop";
import ClientMobile from "./ClientMobile";
import { ButtonTextUnderline } from "components/Button";
import { Link } from "react-router-dom";
import { getClients } from "services/Homepage";

const HomeClient = (props) => {
  const [clientList, setClientList] = useState(null);

  async function fetchClients() {
    const resultDesktop = await getClients("homepage-desktop");
    const resultMobile = await getClients("homepage-mobile");

    setClientList({
      desktop: resultDesktop[0],
      mobile: resultMobile[0],
    });
  }

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <div className="relative py-[29px]">
      <div className="w-full relative md:max-w-[1009px] md:mx-auto md:px-16 md:pt-[100px]">
        <div className="py-[40px] pb-[65px] px-16">
          <div className="flex justify-center">
            <h1 className="text-[64px] md:text-[48px] leading-[51.2px] md:leading-[38.40px] text-neutral-100 font-taviraj hidden md:block">
              Our Happy Client
            </h1>
            <h1 className="text-[48px] leading-[100%] text-neutral-100 font-taviraj block md:hidden">
              Our Client
            </h1>
          </div>
        </div>
        <div className="block min-h-[700px] md:min-h-[340px]">
          {props.windowDimension.width > MAX_RESPONSIVE_MOBILE ? (
            <ClientDesktop data={clientList?.desktop} />
          ) : (
            <ClientMobile data={clientList?.mobile} />
          )}
        </div>
        <div className="w-full max-w-[955px] mx-auto mb-[39px] md:mb-0">
          <div
            className="rounded-[1px] px-24 md:px-[60px] py-20"
            style={{
              background:
                'url("/images/bg-pattern-client.png"), linear-gradient(90deg, #1D070B 0%, #1D0704 51.53%, #3F1C0E 100%)',
              backgroundBlendMode: "soft-light, normal",
            }}
          >
            <div className="flex justify-between items-center gap-24">
              <h4 className="text-primary-800 font-taviraj text-16 md:text-24 leading-[27px] md:leading-[41px]">
                Get to know about Eternal Petite
              </h4>
              <div className="block shrink-0">
                <Link to="/about">
                  <ButtonTextUnderline className="!text-20 md:!text-24 !leading-[20px] md:!leading-normal">
                    Learn More
                  </ButtonTextUnderline>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withDimension(HomeClient);
